/**
 * Admin-entered links (CMS → Social Links) render as `<a href>`. Only http(s)
 * URLs are allowed through so a stored `javascript:` / `data:` URL can never
 * become a clickable script. The backend validates on write too; this guards
 * rows saved before that check existed.
 */
export function isHttpUrl(url: unknown): url is string {
  if (typeof url !== 'string') return false;
  try {
    const { protocol } = new URL(url);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}
